import { IonButton, IonCol, IonContent, IonInput, IonPage, IonRow, IonText, IonSpinner, IonIcon } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert'
import Select from "react-select"
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import { MultiValueRemove } from "react-select/dist/declarations/src/components/MultiValue"


const MemberTimeLog: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText]: any = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [modalopen, setModalopen] = useState(false);
    const [modalKey, setModalKey] = useState(0)
    const [modalopen1, setModalopen1] = useState(false);

    const [id] = useState(localStorage.getItem("SignupEmpId"));
    const [empCode] = useState(localStorage.getItem("empCode"));

    const [Project, setProject] = useState([]);

    /*................View................ */
    const [date, setDate] = useState("");
    const [status, setStatus] = useState();
    const [edit, setEdit] = useState(false);
    const [status1, setStatus1] = useState("");
    const [status2, setStatus2] = useState("");
    const [forceRerender, setForceRerender] = useState(false);


    /*................. Create ................. */
    const [logDate, setLogDate] = useState("");

    const [activityMap, setActivityMap]: any = useState([]);
    const [statusList, setStatusList]: any = useState([]);

    const [activityMapList, setActivityMapList]: any = useState([]);
    const [ids, setids] = useState([])
    // ................. Loading ................//
    const [isLoading, setIsLoading] = useState(false);

    // .................Project Autocomplete ................//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [selectedTimelogId, setSelectedTimelogId] = useState("");
    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = (index: any) => {
        setMenuIsOpen(index);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Project</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    type ProjectType = {
        projectId: string;
        project: string;
    };


    // .................Activity Autocomplete ................//

    const [selectedOption1, setSelectedOption1] = useState(null);
    const [inputValue1, setInputValue1] = useState('');
    const [isFocused1, setIsFocused1] = useState(false);
    const [menuIsOpen1, setMenuIsOpen1] = useState(false);

    const handleStateChange1 = (selectedOption1: any) => {
        setSelectedOption1(selectedOption1);
    };

    const handleInputChange1 = (inputValue1: any) => {
        setInputValue1(inputValue1);
    };

    const handleMenuOpen1 = (index: any) => {
        setMenuIsOpen1(index);
    };

    const handleMenuClose1 = () => {
        setMenuIsOpen1(false);
    };

    const handleFocus1 = () => {
        setIsFocused1(true);
    };

    const handleBlur1 = () => {
        setIsFocused1(false);
    };

    const Placeholder1 = () => {
        if (inputValue1 === '' && !selectedOption1 && !isFocused1) {
            return <span style={{ color: "black" }}>Select Activity</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator1: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    // .................Project Autocomplete(view) ................//

    const [selectedOption2, setSelectedOption2] = useState(null);
    const [inputValue2, setInputValue2] = useState('');
    const [isFocused2, setIsFocused2] = useState(false);
    const [menuIsOpen2, setMenuIsOpen2] = useState(false);

    const handleStateChange2 = (selectedOption2: any) => {
        setSelectedOption2(selectedOption2);
    };

    const handleInputChange2 = (inputValue2: any) => {
        setInputValue2(inputValue2);
    };

    const handleMenuOpen2 = (index: any) => {
        setMenuIsOpen2(index);
    };

    const handleMenuClose2 = () => {
        setMenuIsOpen2(false);
    };

    const handleFocus2 = () => {
        setIsFocused2(true);
    };

    const handleBlur2 = () => {
        setIsFocused2(false);
    };

    const Placeholder2 = () => {
        if (inputValue2 === '' && !selectedOption2 && !isFocused2) {
            return <span style={{ color: "black" }}>Select Project</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator2: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    // .................Activity Autocomplete ................//

    const [selectedOption3, setSelectedOption3] = useState(null);
    const [inputValue3, setInputValue3] = useState('');
    const [isFocused3, setIsFocused3] = useState(false);
    const [menuIsOpen3, setMenuIsOpen3] = useState(false);

    const handleStateChange3 = (selectedOption3: any) => {
        setSelectedOption3(selectedOption3);
    };

    const handleInputChange3 = (inputValue3: any) => {
        setInputValue3(inputValue3);
    };

    const handleMenuOpen3 = (index: any) => {
        setMenuIsOpen3(index);
    };

    const handleMenuClose3 = () => {
        setMenuIsOpen3(false);
    };

    const handleFocus3 = () => {
        setIsFocused3(true);
    };

    const handleBlur3 = () => {
        setIsFocused3(false);
    };

    const Placeholder3 = () => {
        if (inputValue3 === '' && !selectedOption3 && !isFocused3) {
            return <span style={{ color: "black" }}>Select Activity </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator3: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    let curr = new Date();
    curr.setDate(curr.getDate());
    let maxDate = curr.toISOString().substring(0, 10);

    const inputArr = [
        {
            projectId: "",
            activity: "",
            workdescription: "",
            hours: "0",
            minutes: "00",
            selectedProjectOption: null,
            selectedActivityOption: null,
        }
    ];

    // .................Hours Autocomplete ................//

    const [selectedOption4, setSelectedOption4] = useState(null);
    const [inputValue4, setInputValue4] = useState('');
    const [isFocused4, setIsFocused4] = useState(false);
    const [menuIsOpen4, setMenuIsOpen4] = useState(false);

    const handleStateChange4 = (selectedOption4: any) => {
        setSelectedOption4(selectedOption4);
    };

    const handleInputChange4 = (inputValue4: any) => {
        setInputValue4(inputValue4);
    };

    const handleMenuOpen4 = (index: any) => {
        setMenuIsOpen4(index);
    };

    const handleMenuClose4 = () => {
        setMenuIsOpen4(false);
    };

    const handleFocus4 = () => {
        setIsFocused4(true);
    };

    const handleBlur4 = () => {
        setIsFocused4(false);
    };

    const Placeholder4 = () => {
        if (inputValue4 === '' && !selectedOption4 && !isFocused4) {
            return <span style={{ color: "black" }}>Select Hours </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator4: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options = [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        { value: '15', label: '15' },
        { value: '16', label: '16' },
        { value: '17', label: '17' },
        { value: '18', label: '18' },
        { value: '19', label: '19' },
        { value: '20', label: '20' },
        { value: '21', label: '21' },
        { value: '22', label: '22' },
        { value: '23', label: '23' }
    ];

    // .................Minutes Autocomplete ................//

    const [selectedOption5, setSelectedOption5] = useState(null);
    const [selectedOption6, setSelectedOption6] = useState(null);
    const [inputValue5, setInputValue5] = useState('');
    const [isFocused5, setIsFocused5] = useState(false);
    const [menuIsOpen5, setMenuIsOpen5] = useState(false);

    const handleStateChange5 = (selectedOption5: any) => {
        setSelectedOption5(selectedOption5);
    };

    const handleInputChange5 = (inputValue5: any) => {
        setInputValue5(inputValue5);
    };

    const handleMenuOpen5 = (index: any) => {
        setMenuIsOpen5(index);
    };

    const handleMenuClose5 = () => {
        setMenuIsOpen5(false);
    };

    const handleFocus5 = () => {
        setIsFocused5(true);
    };

    const handleBlur5 = () => {
        setIsFocused5(false);
    };

    const Placeholder5 = () => {
        if (inputValue5 === '' && !selectedOption5 && !isFocused5) {
            return <span style={{ color: "black" }}>Select Minutes </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search...</span>;
        }
    };

    const DropdownIndicator5: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options1 = [
        { value: '00', label: '00' },
        { value: '15', label: '15' },
        { value: '30', label: '30' },
        { value: '45', label: '45' },
    ];

    //-----------------AddMore Create & View------------------------//

    const [timeloglist, setTimeloglist]: any = useState(inputArr);
    const addmore = () => {
        var valSet = isFoundTimelog('');
        if (!valSet) {
            setTimeloglist([...timeloglist, { projectId: "", activity: "", workdescription: "", hours: "0", minutes: "00" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const isFoundTimelog = (val: any) => {
        return timeloglist.some((item: any) => (val === item.projectId || val === item.activity || val === item.hours || val === item.minutes));
    }

    //------------------Addmore update -------------------------//

    const [timelog, setTimelog]: any = useState([]);

    const addmoreOnUpdate = () => {
        var valSet = isFoundTimelogOnUpdate('');
        if (!valSet) {
            setTimelog([...timelog, { projectId: "", activity: "", workdescription: "", hours: "0", minutes: "00" }])
            return;
        }
        else {
            swal("", "Enter Details before adding a new row", "info")
        }
    }

    const isFoundTimelogOnUpdate = (val: any) => {
        return timelog.some((item: any) => (val === item.projectId || val === item.activity || val === item.hours || val === item.minutes));
    }

    const Remove = (item: any) => {
        const rows = [...timeloglist]
        var index = timeloglist.indexOf(item)
        if (rows.length > 1) {
            rows.splice(index, 1);
        }
        setTimeloglist(rows);
    }

    //-----------------Remove for singleTimelog---------------//

    // const RemoveTimelog = (item: any) => {
    //     console.log("Before removal: ", timelog);
    //     const rows = [...timelog];
    //     var index = timelog.indexOf(item)
    //     if(rows.length > 1){
    //         if (rows.length > 1) {
    //             rows.splice(index, 1);
    //         }
    //         console.log("After removal: ", rows);
    //         setTimelog(rows);    
    //     }
    //     else{
    //         console.log("Selected Timelog ID before removal: ", selectedTimelogId);
    //         RemoveOnUpdate(selectedTimelogId);
    //     }
    // }
    const RemoveTimelog = (item: any, i: any) => {
        console.log("Before removal: ", timelog, i);
        const rows = [...timelog];
        if (rows.length > 1) {
            rows.splice(i, 1);
            console.log("After removal: ", rows);
            setTimelog(rows);
            setModalKey(modalKey + 1)
            console.log("State updated. New timelog: ", [...rows]);
        } else {
            console.log("Selected Timelog ID before removal: ", selectedTimelogId);
            RemoveOnUpdate(selectedTimelogId);
        }
    };
    //----------------Remove Entire Timelog Api--------------//

    const RemoveOnUpdate = (idToRemove: any) => {
        swal({
            title: 'Are you sure?',
            text: 'If this log is removed, the entire timelog for this date will be removed ',
            icon: 'warning',
            buttons: {

                confirm: {
                    text: 'OK',
                    className: 'green-button-class',
                },
                cancel: 'Cancel',

            } as any,

        }).then((confirmed) => {
            if (confirmed) {
                console.log('Confirmed');
                service.RemoveTimelogs(idToRemove)
                    .then((response) => {
                        console.log(response);
                        window.location.reload();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                console.log('Cancelled');
            }
        });
    }

    //---------------Getall Timelog Api------------//

    const [Id, setId] = useState("");

    useEffect(() => {
        GetTimeLog();
    }, []);

    const GetTimeLog = () => {
        setIsLoading(true)
        ProjectNameGet();
        GetStatus()
        service.GetTimelogListByEmpCode(empCode)
            .then((response) => {
                console.log("RESPONSE", response);
                if (response.data.Status === '200') {
                    setData([]);
                    for (let i = 0; i < response.data.Data.length; i++) {
                        if (response.data.Data[i].timeLogList != null) {
                            setData((prevData: any) => [
                                ...prevData,
                                response.data.Data[i]
                            ]);
                            setids(response.data.Data[i].id);
                            console.log("sacdsc", ids);

                        }
                    }
                }
                else {
                    setData([]);
                }

            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    //-------------------Status Api-------------//

    const GetStatus = () => {
        service.CreateTimeLogStatusDropDown()
            .then((response) => {
                console.log(response, "Status List");
                if (response.data.Status === "200") {
                    setStatusList(response.data.Data)
                }
                else {
                    setStatusList([]);
                }
            })
    }

    //---------------------Getall Timelog Datatable------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "160px"
        },
        {
            name: "Date",
            sortable: true,
            selector: (itme: any) => itme.date,
            cell: (itme: any) => moment(itme.date).format("DD-MM-YYYY")
        },
        {
            name: "Status",
            sortable: true,
            selector: (itme: any) => itme.status.status,
            cell: (itm: any) => (
                <>
                    <IonText className={itm.status.status === "Approved" ? "color_approve" : itm.status.status === "Open" || itm.status.status === "Submitted" ? "color_progress" : "color_deny"}>{itm.status.status}</IonText>
                </>
            )
        },
        {
            name: " Action",
            sortable: false,
            cell: (itm: any) => (
                <>
                    <div style={{ textDecoration: 'underline', textDecorationColor: "coral", paddingLeft: "15px" }}>
                        <IonText onClick={() => ViewTimeLog(itm.id)} style={{ color: "coral", cursor: 'pointer' }} >View</IonText>
                    </div>
                </>
            )
        },

    ];


    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                padding: "0px",
                justifyContent: "center"
            },
        },
        row: {
            style: {
            }
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center",
                padding: "0px"
            }
        }
    };
    //------------Search for Date(dd-mm-yyyy)--------------//

    const datatable = data.filter((item: any) => {
        const dateStr = item.date;
        const searchText = filterText.toLowerCase();
        const formattedDate = formatDateForComparison(dateStr);
        return (
            JSON.stringify(item).toLowerCase().includes(searchText) ||
            formattedDate.includes(searchText)
        );
    });
    function formatDateForComparison(dateStr: string) {
        const [day, month, year] = dateStr.split('-');
        return `${year}-${month}-${day}`;
    }

    //--------------------Search Filter-------------//

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    const closemodal = () => {
        setId("");
        setModalopen(false)
        setTimelog([])
        setEdit(false)
    }

    //---------------------Create Timelog Api-------------------//

    const Create = () => {
        if (logDate === "") {
            swal("", "Please Select Log Date", "info");
        } else {
            setIsLoading(true);
            console.log(timeloglist);
            var projectId;
            var activity;
            var hours1;
            for (let i = 0; i < timeloglist.length; i++) {
                if (timeloglist[i].activity === "") {
                    activity = "";
                }
                if (timeloglist[i].projectId === "") {
                    projectId = "";
                }
                if (timeloglist[i].hours === "0" && timeloglist[i].minutes === "00") {
                    hours1 = "";
                }
            }

            if (projectId === "") {
                setIsLoading(false);
                swal("", "Please Select Project", "info");
            } else if (activity === "") {
                setIsLoading(false);
                swal("", "Please Select Activity", "info");
            } else if (hours1 === "") {
                setIsLoading(false);
                swal("", "Effort Cannot be Zero(O)", "info");
            } else {
                const delay = new Promise((resolve) => {
                    setTimeout(resolve, 2000);
                });
                Promise.all([
                    delay,
                    service.MemberTimeLogSave(Id, logDate, id, timeloglist, status1),
                ])
                    .then(([_, response]) => {
                        console.log(response);
                        if (response.data.status === "200") {
                            swal("", "Created Successfully", "success");
                            setTimeout(() => {
                                window.location.reload();
                            }, 1000);
                        } else {
                            swal("", response.data.message, "info");
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        swal("", "Error occurred while saving the time log", "error");
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }
    };

    //------------------Update Timelog---------------//

    const Update = () => {
        console.log(status2, "kmk")
        console.log(timelog, "km")
        console.log('Selected Project ID:', projectId);
        // console.log('Selected Project ID:', activity);
        var projectId;
        var activity;
        var hours1;
        for (let i = 0; i < timelog.length; i++) {
            if (timelog[i].projectId.length === 0 || timelog[i].projectId === null) {
                projectId = ""
            }
            if (timelog[i].activity.length === 0) {
                activity = ""
            }
            if (timelog[i].hours === "0" && timelog[i].minutes === "00") {
                hours1 = ""
            }
            // if (timelog[i].minutes === "00") {
            //     minutes = ""
            // }
        }

        if (projectId === "") {
            swal("", "Please Select Project", "info");
        }
        else if (activity === "") {
            swal("", "Please Select Activity", "info");
        }
        else if (hours1 === "") {
            swal("", "Effort Cannot be Zero(O)", "info");
        }
        // else if (timeloglist[i].minutes.length === 0) {
        //     swal("", "Please Select Minutes", "info");
        // }
        else {
            service.MemberTimeLogSave(Id, date, id, timelog, status2)
                .then((response) => {
                    console.log(response)
                    if (response.data.status === "200") {
                        swal("", "Updated Successfully", "success");
                        setId("");
                        window.location.reload();
                    }
                    else {
                        swal("", response.data.message, "info");
                    }
                })
        }
    }

    const closemodal1 = () => {
        setModalopen1(false)
        setTimeloglist(inputArr)
    }

    //--------------ProjectName Dropdown in create api-----------//

    const ProjectNameGet = () => {
        service.TimelogGetProjectNameById(id)
            .then((response) => {
                console.log(response, "Project");
                if (response.data.data != null) {
                    setProject(response.data.data);
                }
                else {
                    setProject([])
                }
            })
    }
    //----------------Activity Dropdown Api-------------------//

    const activity = (id: any, j: any) => {
        service.GetActivityListByProjectId(id)
            .then((response) => {
                console.log(response, "Activity List");
                if (response.data.status === "200") {
                    setActivityMapList((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[j] = response.data.data;
                        return updatedActivityMap;
                    });
                } else {
                    setActivityMapList((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[j] = [];
                        return updatedActivityMap;
                    });
                }
            })
    }
    //------------View Timelog api-------------//

    const ViewTimeLog = (id: any) => {
        setSelectedTimelogId(id);
        setId(id)
        setModalopen(true);
        var sttr = "";
        service.MemberTimeLogViewById(id)
            .then((response) => {
                console.log(response, "kmk")
                if (response.data.status === "200") {
                    if (response.data.Data.date === null || response.data.Data.date === "") {
                        setDate("")
                    }
                    else {
                        setDate(response.data.Data.date);
                    }
                    if (response.data.Data.timeLogList.length > 0) {
                        setTimelog(response.data.Data.timeLogList)
                    }
                    for (let i = 0; i < response.data.Data.timeLogList.length; i++) {
                        sttr = response.data.Data.timeLogList[i].projectId
                        activity(sttr, i)
                    }
                    setStatus(response.data.Data.status.status);
                    setStatus2(response.data.Data.status.id);
                }
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const CreateTimeLog = () => {
        setModalopen1(true);
    }

    //---------------Addmore project----------------//

    const handleProject = (selectedOption: any, i: any) => {
        const updatedTimeloglist = [...timeloglist];
        updatedTimeloglist[i].projectId = selectedOption.value;
        updatedTimeloglist[i].selectedProjectOption = selectedOption;
        setTimeloglist(updatedTimeloglist);
        service.GetActivityListByProjectId(selectedOption.value)
            .then((response) => {
                console.log(response, "Activity List");
                if (response.data.status === "200") {
                    setActivityMap((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[i] = response.data.data;
                        return updatedActivityMap;
                    });
                } else {
                    setActivityMap((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[i] = [];
                        return updatedActivityMap;
                    });
                }
            });

        for (let i = 0; i < statusList.length; i++) {
            if (statusList[i].status === "Open") {
                setStatus1(statusList[i].id);
            }
        }
    };

    //----------------Addmore activity-------------------//

    const handleActivity = (selectedOption1: any, i: any) => {
        const updatedTimeloglist = [...timeloglist];
        updatedTimeloglist[i].activity = selectedOption1.value;
        updatedTimeloglist[i].selectedActivityOption = selectedOption1;
        setTimeloglist(updatedTimeloglist);
    }

    //----------------Addmore Description-------------------//

    const handleWork = (e: any, i: any) => {
        timeloglist[i].workdescription = e.target.value
    }

    //----------------Addmore hours-------------------//

    const handleHours = (selectedoption6: any, i: any) => {
        timeloglist[i].hours = selectedoption6.value
        timeloglist[i].hour = selectedoption6.value
    }

    //----------------Addmore Minutes-------------------//

    const handleMins = (selectedOption7: any, i: any) => {
        timeloglist[i].minutes = selectedOption7.value;
    }

    //----------------Addmore Projectupdate in view-------------------//

    const handleProjectOnUpdate = (selectedOption2: any, i: any) => {
        console.log('Selected Project:', selectedOption2);
        const updatedTimeloglist = [...timelog];
        updatedTimeloglist[i].projectId = selectedOption2.value;
        updatedTimeloglist[i].selectedProjectupdateOption = selectedOption2;

        setTimelog(updatedTimeloglist);
        const projectId = selectedOption2.value;
        // Update(projectId);
        service.GetActivityListByProjectId(projectId)
            .then((response) => {
                console.log(response, "Activity List");
                if (response.data.status === "200") {
                    setActivityMapList((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[i] = response.data.data;
                        return updatedActivityMap;
                    });
                } else {
                    setActivityMapList((prevActivityMap: any) => {
                        const updatedActivityMap: any = { ...prevActivityMap };
                        updatedActivityMap[i] = [];
                        return updatedActivityMap;
                    });
                }
            })
            .catch((error) => {
                console.error('Error fetching activities:', error);
            });
    };

    //----------------Addmore Activityupdate in view-------------------//

    const handleActivityOnUpdate = (selectedOption3: any, i: any) => {
        const updatedTimelog = [...timelog];
        updatedTimelog[i].activity = selectedOption3.value;
        updatedTimelog[i].selectedActivityupdateOption = selectedOption3;
        setTimelog(updatedTimelog);
    }

    //----------------Addmore Workupdate in view-------------------//

    const handleWorkOnUpdate = (e: any, i: any) => {
        timelog[i].workdescription = e.target.value
    }

    //----------------Addmore Hoursupdate in view-------------------//

    const handleHoursOnUpdate = (selectedOption4: any, i: any) => {
        timelog[i].hours = selectedOption4.value
        timelog[i].hour = selectedOption4.value
    }

    //----------------Addmore Minutesupdate in view-------------------//

    const handleMinsOnUpdate = (selectedOption5: any, i: any) => {
        timelog[i].minutes = selectedOption5.value;
    }
    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />Time Log</h3>
                                </div>
                                <div className="col-auto float-end ml-auto">
                                    <a onClick={() => CreateTimeLog()} className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_leave"><i className="fa fa-plus" /> Create Time Log</a>
                                </div>
                            </div>
                            {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                    }}
                                >
                                    <div >
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                                <DataTable
                                    columns={columns}
                                    data={datatable}
                                    pagination
                                    paginationPerPage={10}
                                    paginationComponentOptions={paginationComponentOptions}
                                    paginationRowsPerPageOptions={[10, 20, 30]}
                                    subHeader
                                    subHeaderComponent={subHeaderComponent}
                                    customStyles={customStyles}
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/*..................Create Modal................ */}

                <Modal
                    id="logouts-modal"
                    show={modalopen1}
                    dialogClassName="my-modal modal-dialog-centered"
                >
                    <div className="modal-header">
                        <h5 className="modal-title">Create Time Log</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal1()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>Log Date <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput onIonChange={(e: any) => setLogDate(e.detail.value)} type='date' max={maxDate} className="form-control datetimepicker" />
                                </div>
                            </div>
                        </div>
                        {timeloglist.map((item: any, i: any) => {
                            return (
                                <form className="addmore">
                                    <div className="row">
                                        <div className="col-md-7">
                                            <label style={{ fontWeight: "bold" }}>Log {i + 1} :</label>
                                        </div>
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: "bold" }}>Effort <span className="text-danger">*</span></label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}>Project <span className="text-danger">*</span></label>
                                            <div>
                                                <Select
                                                    options={Project.map((state: ProjectType) => ({
                                                        value: state.projectId,
                                                        label: state.project,
                                                    }))}
                                                    value={item.selectedProjectOption}
                                                    onChange={(selectedOption: any) => handleProject(selectedOption, i)}
                                                    onInputChange={handleInputChange}
                                                    onMenuOpen={() => handleMenuOpen(i)}
                                                    onMenuClose={handleMenuClose}
                                                    onFocus={handleFocus}
                                                    onBlur={handleBlur}
                                                    menuIsOpen={menuIsOpen === i}
                                                    isSearchable
                                                    placeholder={<Placeholder />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator,
                                                    }}
                                                    styles={{
                                                        control: (provided: any) => ({
                                                            ...provided,
                                                            backgroundColor: '#ffffff',
                                                            color: '#000000',
                                                        }),
                                                    }}
                                                    className={menuIsOpen === i ? "custom-select6" : ""}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Activity <span className="text-danger">*</span></label>
                                            <div className="select">
                                                <Select
                                                    options={activityMap[i]?.map((state: any) => ({
                                                        value: state,
                                                        label: state,
                                                    }))}
                                                    value={item.selectedActivityOption}
                                                    onChange={(selectedOption1: any) => handleActivity(selectedOption1, i)}
                                                    onInputChange={handleInputChange1}
                                                    onMenuOpen={() => handleMenuOpen1(i)}
                                                    onMenuClose={handleMenuClose1}
                                                    onFocus={handleFocus1}
                                                    onBlur={handleBlur1}
                                                    menuIsOpen={menuIsOpen1 === i}
                                                    isSearchable
                                                    placeholder={<Placeholder1 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator1,
                                                    }}
                                                    styles={{
                                                        control: (provided: any) => ({
                                                            ...provided,
                                                            backgroundColor: '#ffffff',
                                                            color: '#000000',
                                                        }),
                                                    }}
                                                    className={menuIsOpen1 === i ? "custom-select7" : ""}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Work Description </label>
                                            <div>
                                                <IonInput value={item.workdescription} onIonChange={(e: any) => handleWork(e, i)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Hours</label>
                                            <div>
                                                <Select
                                                    value={options.find(option => option.value === item.hours)}
                                                    onChange={(selectedOption4: any) => handleHours(selectedOption4, i)}
                                                    options={options}
                                                    //value={item.hour}
                                                    onInputChange={handleInputChange4}
                                                    onMenuOpen={() => handleMenuOpen4(i)}
                                                    onMenuClose={handleMenuClose4}
                                                    onFocus={handleFocus4}
                                                    onBlur={handleBlur4}
                                                    menuIsOpen={menuIsOpen4 === i}
                                                    isSearchable
                                                    placeholder={<Placeholder4 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator4,
                                                    }}
                                                    className={menuIsOpen4 === i ? "custom-select7" : ""}
                                                    styles={{
                                                        control: (provided: any) => ({
                                                            ...provided,
                                                            backgroundColor: '#ffffff',
                                                            color: '#000000'
                                                        }),

                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <label style={{
                                                fontWeight: "bold",
                                                ...(window.innerWidth || document.documentElement.clientWidth) <= 768 && { marginTop: "10px" }
                                            }}>
                                                Minutes
                                            </label>
                                            <div>
                                                <Select
                                                    value={options1.find(option => option.value === item.minutes)}
                                                    onChange={(selectedOption5: any) => handleMins(selectedOption5, i)}
                                                    options={options1}
                                                    //value={item.hour}
                                                    onInputChange={handleInputChange5}
                                                    onMenuOpen={() => handleMenuOpen5(i)}
                                                    onMenuClose={handleMenuClose5}
                                                    onFocus={handleFocus5}
                                                    onBlur={handleBlur5}
                                                    menuIsOpen={menuIsOpen5 === i}
                                                    isSearchable
                                                    placeholder={<Placeholder5 />}
                                                    components={{
                                                        DropdownIndicator: DropdownIndicator5,
                                                    }}
                                                    className={menuIsOpen5 === i ? "custom-select7" : ""}
                                                    styles={{
                                                        control: (provided: any) => ({
                                                            ...provided,
                                                            backgroundColor: '#ffffff',
                                                            color: '#000000'
                                                        }),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            {timeloglist.length > 1 ?
                                                <div style={{ marginTop: "25px" }}>
                                                    <button onClick={() => Remove(item)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                </div> : <></>}
                                        </div>
                                    </div>
                                </form>
                            )
                        })}


                        <div style={{
                            display: "flex",
                            marginTop: "15px"
                        }}>
                            <button onClick={() => addmore()} type="button" className="btn btn-primary"><i className="fa fa-plus" /> Add More</button>
                        </div>
                        {isLoading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}
                        {/* {!isLoading && (
                            <> */}
                        <div className="submit-section">
                            <button type="button" className="btn-primary submit-btn" onClick={() => Create()}>Create</button>
                        </div>
                        {/*
                            </>
                        )} */}

                    </div>

                </Modal>

                {/*..................View Modal.................. */}

                <Modal
                    id="logouts-modal"
                    show={modalopen}
                    dialogClassName="my-modal modal-dialog-centered"
                    key={modalKey}
                >
                    <div className="modal-header">
                        <h5 className="modal-title">View Time Log</h5>
                        <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="form-group col-md-3">
                                <label style={{ fontWeight: "bold" }}>Log Date <span className="text-danger">*</span></label>
                                <div>
                                    <IonInput value={moment(date).format("DD-MM-YYYY")} readonly className="form-control datetimepicker" style={{ backgroundColor: "#DCDCDC" }} />
                                </div>
                            </div>
                        </div>
                        {timelog.map((item: any, i: any) => {
                            var str: any;
                            var str1;
                            str1 = item.activity
                            if (item.projectId === null || item.projectId === "") {
                                str = "";
                            }
                            else {
                                str = item.project ? item.project.projectName : "";
                            }
                            return (
                                <form key={i} className="addmore" >
                                    <div className="row">
                                        <div className="col-md-7">
                                            <label style={{ fontWeight: "bold" }}>Log {i + 1} :</label>
                                        </div>
                                        <div className="col-md-3">
                                            <label style={{ fontWeight: "bold" }}>Effort <span className="text-danger">*</span></label>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-md-3">
                                            <label style={{ fontWeight: "bold" }}>Project <span className="text-danger">*</span></label>
                                            <div>
                                                {edit === false ? (
                                                    <IonInput readonly value={str} className="form-control datetimepicker" />
                                                ) : (
                                                    <Select
                                                        options={Project ? Project.map((state: any) => ({
                                                            value: state.projectId,
                                                            label: state.project
                                                        })) : []}
                                                        defaultValue={
                                                            str
                                                                ? { value: str, label: str }
                                                                : null
                                                        }
                                                        value={item.selectedProjectupdateOption}
                                                        onChange={(selectedOption2: any) => handleProjectOnUpdate(selectedOption2, i)}
                                                        onInputChange={handleInputChange2}
                                                        onMenuOpen={() => handleMenuOpen2(i)}
                                                        onMenuClose={handleMenuClose2}
                                                        onFocus={handleFocus2}
                                                        onBlur={handleBlur2}
                                                        menuIsOpen={menuIsOpen2 === i}
                                                        isSearchable
                                                        placeholder={<Placeholder2></Placeholder2>}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator2,
                                                        }}
                                                        className={menuIsOpen2 === i ? "custom-select9" : ""}
                                                        styles={{
                                                            control: (provided: any) => ({
                                                                ...provided,
                                                                backgroundColor: '#ffffff',
                                                                color: '#000000',
                                                            }),
                                                        }}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                        <div className="form-group col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Activity <span className="text-danger">*</span></label>
                                            <div>
                                                {edit === false ? (
                                                    <IonInput readonly value={str1} className="form-control datetimepicker" />
                                                ) : (
                                                    <Select
                                                        options={(activityMapList[i] || []).map((state: any) => ({
                                                            value: state,
                                                            label: state,
                                                        }))}
                                                        defaultValue={
                                                            str1 && edit ? { value: str1, label: str1 } : null
                                                        }
                                                        value={item.selectedActivityupdateOption}
                                                        onChange={(selectedOption3: any) => handleActivityOnUpdate(selectedOption3, i)}
                                                        onInputChange={handleInputChange3}
                                                        onMenuOpen={() => handleMenuOpen3(i)}
                                                        onMenuClose={handleMenuClose3}
                                                        onFocus={handleFocus3}
                                                        onBlur={handleBlur3}
                                                        menuIsOpen={menuIsOpen3 === i}
                                                        isSearchable
                                                        placeholder={<Placeholder3></Placeholder3>}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator3,
                                                        }}
                                                        className={menuIsOpen3 === i ? "custom-select7" : ""}
                                                        styles={{
                                                            control: (provided: any) => ({
                                                                ...provided,
                                                                backgroundColor: '#ffffff',
                                                                color: '#000000',
                                                            }),
                                                        }}
                                                    />
                                                )}
                                            </div>

                                        </div>
                                        <div className="form-group col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Work Description </label>
                                            <div>
                                                {edit ? (
                                                    <IonInput value={item.workdescription} onIonChange={(e: any) => handleWorkOnUpdate(e, i)} className="form-control datetimepicker" />
                                                ) : (
                                                    <IonInput value={item.workdescription} readonly onIonChange={(e: any) => handleWorkOnUpdate(e, i)} className="form-control datetimepicker" />

                                                )}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <label style={{ fontWeight: "bold" }}>Hours</label>
                                            <div style={{ backgroundColor: "#DCDCDC" }}>
                                                {edit ? (
                                                    <Select
                                                        value={options.find(option => option.value === item.hours)}
                                                        onChange={(selectedOption4: any) => handleHoursOnUpdate(selectedOption4, i)}
                                                        // isDisabled={edit === false ? true : false}
                                                        options={options}
                                                        //value={item.hour}
                                                        onInputChange={handleInputChange4}
                                                        onMenuOpen={() => handleMenuOpen4(i)}
                                                        onMenuClose={handleMenuClose4}
                                                        onFocus={handleFocus4}
                                                        onBlur={handleBlur4}
                                                        menuIsOpen={menuIsOpen4 === i}
                                                        isSearchable
                                                        placeholder={<Placeholder4 />}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator4,
                                                        }}
                                                        className={menuIsOpen4 === i ? "custom-select7" : ""}
                                                        styles={{
                                                            control: (provided: any) => ({
                                                                ...provided,
                                                                backgroundColor: '#ffffff',
                                                                color: '#000000'
                                                            }),

                                                        }}
                                                    />
                                                ) : (
                                                    <IonInput readonly value={item.hours} className="form-control datetimepicker" />
                                                )}
                                                {/*
                                                <select defaultValue={item.hours} onChange={(e: any) => handleHoursOnUpdate(e, i)} disabled={edit === false ? true : false} className="select" style={{
                                                    backgroundColor: '#ffffff',
                                                    color: '#000000',
                                                }}>
                                                    <option disabled selected value="">Select Hours</option>
                                                    <option value="0">0</option>
                                                    <option value="1">1</option>
                                                    <option value="2">2</option>
                                                    <option value="3">3</option>
                                                    <option value="4">4</option>
                                                    <option value="5">5</option>
                                                    <option value="6">6</option>
                                                    <option value="7">7</option>
                                                    <option value="8">8</option>
                                                    <option value="9">9</option>
                                                    <option value="10">10</option>
                                                    <option value="11">11</option>
                                                    <option value="12">12</option>
                                                    <option value="13">13</option>
                                                    <option value="14">14</option>
                                                    <option value="15">15</option>
                                                    <option value="16">16</option>
                                                    <option value="17">17</option>
                                                    <option value="18">18</option>
                                                    <option value="19">19</option>
                                                    <option value="20">20</option>
                                                    <option value="21">21</option>
                                                    <option value="22">22</option>
                                                    <option value="23">23</option>
                                                </select> */}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <label style={{
                                                fontWeight: "bold",
                                                ...(window.innerWidth || document.documentElement.clientWidth) <= 768 && { marginTop: "10px" }
                                            }}>
                                                Minutes
                                            </label>

                                            <div>
                                                {edit ? (
                                                    <Select
                                                        value={options1.find(option => option.value === item.minutes)}
                                                        onChange={(selectedOption5: any) => handleMinsOnUpdate(selectedOption5, i)}
                                                        // isDisabled={edit === false ? true : false}
                                                        options={options1}
                                                        //value={item.hour}
                                                        onInputChange={handleInputChange5}
                                                        onMenuOpen={() => handleMenuOpen5(i)}
                                                        onMenuClose={handleMenuClose5}
                                                        onFocus={handleFocus5}
                                                        onBlur={handleBlur5}
                                                        menuIsOpen={menuIsOpen5 === i}
                                                        isSearchable
                                                        placeholder={<Placeholder5 />}
                                                        components={{
                                                            DropdownIndicator: DropdownIndicator5,
                                                        }}
                                                        className={menuIsOpen5 === i ? "custom-select7" : ""}
                                                        styles={{
                                                            control: (provided: any) => ({
                                                                ...provided,
                                                                backgroundColor: '#ffffff',
                                                                color: '#000000'
                                                            }),

                                                        }}
                                                    />
                                                ) : (
                                                    <IonInput readonly value={item.minutes} className="form-control datetimepicker" />
                                                    // <select defaultValue={item.minutes} onChange={(e: any) => handleMinsOnUpdate(e, i)} disabled={edit === false ? true : false} className="select" style={{
                                                    //     backgroundColor: '#e9ecef',
                                                    //     color: '#000000',
                                                    // }}>
                                                    //     <option value="00">00</option>
                                                    //     <option value="15">15</option>
                                                    //     <option value="30">30</option>
                                                    //     <option value="45">45</option>
                                                    // </select>
                                                )}
                                            </div>
                                        </div>
                                        {edit === true ?
                                            <div className="col-md-1">
                                                <div style={{ marginTop: "25px" }}>
                                                    <button onClick={() => RemoveTimelog(item, i)} type="button" className="btn btn-primary"><i className="fa fa-trash-o" /></button>
                                                </div>
                                            </div> : <></>}
                                    </div>
                                </form>
                            )
                        })}

                        {edit === true ? (
                            <div style={{
                                display: "flex",
                                marginTop: "15px"

                            }}>
                                <button onClick={() => addmoreOnUpdate()} type="button" className="btn btn-primary">
                                    <i className="fa fa-plus" /> Add More
                                </button>
                            </div>
                        ) : null}
                        {status != "Approved" ? <div className="row">
                            {edit === false ? <div className="submit-section col-md-6">
                                <button type="button" className="btn-primary submit-btn" onClick={() => setEdit(true)}>Edit</button>
                            </div> :
                                <div className="submit-section col-md-6">
                                    <button type="button" className="btn-primary submit-btn" onClick={() => Update()}>Update</button>
                                </div>}
                            <div className="submit-section col-md-6">
                                <button type="button" className="btn-primary submit-btn" onClick={closemodal}>Back</button>
                            </div>
                        </div> :
                            <div className="submit-section">
                                <button type="button" className="btn-primary submit-btn" onClick={closemodal}>Back</button>
                            </div>}
                    </div>
                </Modal>
            </IonContent>
        </IonPage>
    )
}

export default MemberTimeLog